import React, { useEffect, useState } from 'react';
import DefaultMessage from './message_cards/DefaultMessage';
import AmbulanceIcon from '../../../resources/images/chat_icons/AmbulanceIcon.svg';
import ArcFlashIcon from '../../../resources/images/chat_icons/ArcFlashIcon.svg';
import CarIcon from '../../../resources/images/chat_icons/CarIcon.png';
import DeletedIcon from '../../../resources/images/chat_icons/TrashIcon.svg';
import FallIcon from '../../../resources/images/chat_icons/FallIcon.svg';
import ImpactIcon from '../../../resources/images/chat_icons/ImpactIcon.svg';
import MapIcon from '../../../resources/images/chat_icons/MapIcon.svg';
import NoMovementIcon from '../../../resources/images/chat_icons/NoMovementIcon.svg';
import PhoneIcon from '../../../resources/images/chat_icons/AlternatePhoneIcon.svg';
import SafeIcon from '../../../resources/images/chat_icons/SafeIcon.svg';
import SOSIcon from '../../../resources/images/chat_icons/SOSIcon.svg';
import MessageCard from './message_cards/MessageCard';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../resources/strings/StringKeys';

function Message({ data, emergency }) {
  const [chatData, setChatData] = useState();
  const [medicalPhoneNumber, setMedicalPhoneNumber] = useState('911');
  const [creatorFirstName, setCreatorFirstName] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    setChatData(data);
  }, [data]);

  useEffect(() => {
    if (emergency) {
      const medicalNumber =
        emergency?.emergency?.emergency_numbers?.medical ??
        emergency?.emergency_numbers?.medical;
      if (medicalNumber) setMedicalPhoneNumber(medicalNumber);
      const creatorName = emergency?.emergency?.creator_first_name;
      if (creatorName) setCreatorFirstName(creatorName);
    }
  }, [emergency]);

  const getMessageType = () => {
    if (chatData !== undefined && emergency) {
      if (
        chatData.message_kind === 'defaultMessage' ||
        chatData.message_kind === 'defaultChat'
      ) {
        return <DefaultMessage chatData={chatData} />;
      } else if (chatData.message_kind === 'sosCard') {
        return (
          <MessageCard
            chatData={chatData}
            icon={SOSIcon}
            messageContent={t(StringKeys.SOS)}
            message={t(StringKeys.USER_PRESSED_THE_SOS_BUTTON, {
              user: `${chatData.sender_first_name}`,
            })}
          />
        );
      } else if (chatData.message_kind === 'incidentResolved') {
        return (
          <MessageCard
            chatData={chatData}
            icon={SafeIcon}
            messageContent={t(StringKeys.EVENT_RESOLVED)}
            message={t(StringKeys.USER_CLOSED_THE_EMERGENCY_EVENT, {
              user: `${chatData.sender_first_name}`,
            })}
          />
        );
      } else if (chatData.message_kind === 'noMovementDetectedCard') {
        return (
          <MessageCard
            chatData={chatData}
            icon={NoMovementIcon}
            messageContent={t(StringKeys.NO_MOVEMENT_DETECTED)}
            message={t(StringKeys.USER_HAS_NOT_MOVED_FOR_SIXTY_SECONDS, {
              user: `${chatData.sender_first_name}`,
            })}
          />
        );
      } else if (chatData.message_kind === 'callingCard') {
        return (
          <MessageCard
            chatData={chatData}
            icon={PhoneIcon}
            messageContent={t(StringKeys.CALLING_USER, {
              user: `${creatorFirstName}`,
            })}
            message={t(StringKeys.USER_ONE_IS_CALLING_USER_TWO, {
              userOne: `${chatData.sender_first_name}`,
              userTwo: `${creatorFirstName}`,
            })}
          />
        );
      } else if (chatData.message_kind === 'onMyWayCard') {
        return (
          <MessageCard
            chatData={chatData}
            icon={CarIcon}
            messageContent={t(StringKeys.ON_MY_WAY)}
            message={t(StringKeys.USER_IS_HEADING_TO_THE_EMERGENCY_EVENT, {
              user: `${chatData.sender_first_name}`,
            })}
          />
        );
      } else if (chatData.message_kind === 'Head Impact') {
        return (
          <MessageCard
            chatData={chatData}
            icon={ImpactIcon}
            messageContent={t(StringKeys.HEAD_IMPACT)}
            message={t(StringKeys.USER_EXPERIENCED_A_DANGEROUS_HEAD_IMPACT, {
              user: `${chatData.sender_first_name}`,
            })}
          />
        );
      } else if (chatData.message_kind === 'Arc Flash') {
        return (
          <MessageCard
            chatData={chatData}
            icon={ArcFlashIcon}
            messageContent={t(StringKeys.ARC_FLASH)}
            message={t(StringKeys.USER_EXPERIENCED_AN_ARC_FLASH, {
              user: `${chatData.sender_first_name}`,
            })}
          />
        );
      } else if (chatData.message_kind === 'Fall') {
        return (
          <MessageCard
            chatData={chatData}
            icon={FallIcon}
            messageContent={t(StringKeys.FALL)}
            message={t(StringKeys.USER_EXPERIENCED_A_DANGEROUS_FALL, {
              user: `${chatData.sender_first_name}`,
            })}
          />
        );
      } else if (chatData.message_kind === 'ambulanceNeededCard') {
        return (
          <MessageCard
            chatData={chatData}
            icon={AmbulanceIcon}
            messageContent={`${chatData.content}`}
            message={t(StringKeys.USER_NEEDS_AN_AMBULANCE, {
              user: `${chatData.sender_first_name}`,
            })}
          />
        );
      } else if (chatData.message_kind === 'ambulanceSentCard') {
        return (
          <MessageCard
            chatData={chatData}
            icon={AmbulanceIcon}
            messageContent={t(StringKeys.AMBULANCE_CALLED)}
            message={t(StringKeys.USER_HAS_CALLED_AN_AMBULANCE, {
              user: `${chatData.sender_first_name}`,
            })}
          />
        );
      } else if (chatData.message_kind === 'myLocationCard') {
        return (
          <MessageCard
            chatData={chatData}
            icon={MapIcon}
            messageContent={t(StringKeys.I_AM_HERE)}
            message={
              chatData.address ? (
                `${chatData.address}`
              ) : chatData.latitude != null && chatData.longitude ? (
                `${t(StringKeys.LATITUDE)}: ${chatData.latitude.toPrecision(7)}, ${t(StringKeys.LONGITUDE)}: ${chatData.longitude.toPrecision(7)}`
              ) : (
                <>{t(StringKeys.LOCATION_NOT_AVAILABLE)}</>
              )
            }
          />
        );
      } else if (chatData.message_kind === 'myLocationCardFirst') {
        return (
          <MessageCard
            chatData={chatData}
            icon={MapIcon}
            messageContent={t(StringKeys.EVENT_OCCURRED_HERE)}
            message={
              chatData.address ? (
                `${chatData.address}`
              ) : chatData.latitude != null && chatData.longitude ? (
                `${t(StringKeys.LATITUDE)}: ${chatData.latitude.toPrecision(7)}, ${t(StringKeys.LONGITUDE)}: ${chatData.longitude.toPrecision(7)}`
              ) : (
                <>{t(StringKeys.LOCATION_NOT_AVAILABLE)}</>
              )
            }
          />
        );
      } else if (chatData.message_kind === 'deletedCard') {
        return (
          <MessageCard
            chatData={chatData}
            icon={DeletedIcon}
            messageContent={t(StringKeys.MESSAGE_DELETED)}
            message={t(StringKeys.THIS_MESSAGE_HAS_BEEN_DELETED)}
          />
        );
      } else if (chatData.message_kind === 'called911Card') {
        return (
          <MessageCard
            chatData={chatData}
            icon={PhoneIcon}
            messageContent={t(StringKeys._911_CALLED, {
              medicalNumber: `${medicalPhoneNumber}`,
            })}
            message={t(StringKeys.USER_HAS_CALLED_911, {
              user: `${chatData.sender_first_name}`,
              medicalNumber: `${medicalPhoneNumber}`,
            })}
          />
        );
      } else if (chatData.message_kind === 'safeCard') {
        return (
          <MessageCard
            chatData={chatData}
            icon={SafeIcon}
            messageContent={t(StringKeys.FALSE_ALARM)}
            message={t(StringKeys.USER_IS_OK, {
              user: `${chatData.sender_first_name}`,
            })}
          />
        );
      } else if (chatData.message_kind === 'iNeedHelpCard') {
        return (
          <MessageCard
            chatData={chatData}
            icon={SOSIcon}
            messageContent={t(StringKeys.HELP_NEEDED)}
            message={t(StringKeys.USER_NEEDS_HELP_AT_THEIR_LOCATION, {
              user: `${chatData.sender_first_name}`,
            })}
          />
        );
      }
    }
  };

  return <React.Fragment>{getMessageType()}</React.Fragment>;
}

export default React.memo(Message);
